import React from 'react';
import { Table, Button } from 'react-bootstrap';
import moment from 'moment';
import '../styles/style.css';

interface Order {
  barNo: string;
  deliveryDate: string;
  deliveryStatus: string
  ebOrderRef: string;
  fineness: string;
  orderDate: string;
  productName: string;
  tracking: string;
  weight: string;
  color: string;
  ebInvoiceRef: string;
}

interface PhysicalOrdersProps {
  orders: Order[];
  downloadDeliveryInvoice: (invoiceId: string) => void;
}

const PhysicalOrders: React.FC<PhysicalOrdersProps> = ({
  orders,
  downloadDeliveryInvoice,
}) => {
  return (
    <Table
      className='physical-orders-table mb-0 w-100'
      striped
      hover
      responsive
    >
      <thead className='physical-orders-table__head'>
        <tr>
          <th className='physical-orders-table__cell'>Certicard No.</th>
          <th className='physical-orders-table__cell'>Product</th>
          <th className='physical-orders-table__cell'>Weight</th>
          <th className='physical-orders-table__cell'>Fineness</th>
          <th className='physical-orders-table__cell'>Order Date</th>
          {/* <th className='physical-orders-table__cell'>Delivery Date</th> */}
          <th className='physical-orders-table__cell'>Status</th>
          <th className='physical-orders-table__cell'>Tracking</th>
          <th className='physical-orders-table__cell'>Action</th>
        </tr>
      </thead>
      <tbody className='physical-orders-table__body'>
        {orders.length === 0 ? (
          <tr>
            <td
              className='physical-orders-table__empty text-center'
              colSpan={10}
            >
              No physical delivery orders available
            </td>
          </tr>
        ) : (
          orders.map((order, index) => (
            <tr key={index} className='physical-orders-table__row'>
              <td className='physical-orders-table__cell'>{order.barNo}</td>
              <td className='physical-orders-table__cell'>{order.productName}</td>
              <td className='physical-orders-table__cell'>{order.weight? `${order.weight} g`: "-"}</td>
              <td className='physical-orders-table__cell'>{order.fineness}</td>
              <td className='physical-orders-table__cell'>
                {moment(order.orderDate).format('DD-MMM-yyyy')}
              </td>
              {/* <td className='physical-orders-table__cell'>
                {moment(order.deliveryDate).format('DD-MMM-yyyy')}
              </td> */}
              <td className="physical-orders-table__cell">
                <span
                  style={{
                    display: "inline-block",
                    padding: "3px 10px",
                    borderRadius: "16px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    backgroundColor: "#f5f5f5",
                    color: order.color || "#6c757d",
                    minWidth: "100px",
                    textAlign: "center",
                    whiteSpace: "nowrap"
                  }}
                >
                  {order.deliveryStatus || "—"}
                </span>
              </td>


              <td className='physical-orders-table__cell'>
                {order.tracking ? (
                  <a
                    className='physical-orders-table__track-btn'
                    href={order.tracking}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Track
                    {/* Small upright-right arrow */}
                    <svg
                      className='physical-orders-table__track-icon'
                      viewBox='0 0 12 12' /* larger viewBox */
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M3 9 L9 3 M9 3 H4 M9 3 V8'
                        stroke='currentColor'
                        strokeWidth='1.5' /* thickness of arrow lines */
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </a>
                ) : (
                  '-'
                )}
              </td>

              <td className='physical-orders-table__cell'>
                <Button
                  variant="primary"
                  size="sm"
                  className="physical-orders-table__view-btn"
                  onClick={() => downloadDeliveryInvoice(order.ebInvoiceRef)}
                  title="Download Invoice"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6" />
                    <path d="M12 3v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                  <span className="d-none d-md-inline">Invoice</span>
                </Button>



              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default PhysicalOrders;
